module.exports = __webpack_public_path__ + "img/Silicone fen dash grey.2b4dcc8a.png";